/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
let highestRole = function(roles) {
  let ordered = {};
  ordered = roles.sort(function(a, b) {
    return a.id - b.id;
  });
  console.log(ordered);
  return ordered[0].name;
};

export default {
	UPDATE_AUTHENTICATED_USER(state, info) {
    // TODO: set ROLE ให้ ROLE user ไม่สามารถ set ลง storage ได้
    console.log('UPDATE_AUTHENTICATED_USER', info);
		localStorage.setItem('userInfo', JSON.stringify(info.userInfo));
    localStorage.setItem('userRole', info.userRole);
    state.userRole = info.userRole;
    localStorage.setItem('accessToken', info.accessToken);
  },
  UPDATE_AUTHENTICATED_USER_TOKEN(state, info) {
    localStorage.setItem('accessToken', info.accessToken);
  }, 
  // UPDATE_USER_ROLE(state, val) {
  //   state.userRole = val
  //   localStorage.setItem('userRole', val)
  // },
  LOGIN_SUCCESS(state, payload) {
    console.log(payload.data.user);
    localStorage.setItem("accessUsername", payload.data.user.username);
    localStorage.setItem("accessToken", payload.data.accessToken);
    localStorage.setItem('userRole', highestRole(payload.data.user.roles));
		localStorage.setItem('accessUserId', payload.data.user.userId);
		localStorage.setItem('exciseType', payload.data.user.exciseType);

    state.data = payload.data;
    state.isLoginSuccess = true;
    // router.push("/dashboard");
  },
  LOGIN_ERROR(state, payload) {
    state.error = payload.error;
  },
  LOADING(state, loading) {
    state.loading = loading;
  },
}